import * as React from "react";
import { TaskForm } from "./daily/TaskForm";
import { createTaskFormContext } from "./daily/TaskForm/taskFormContext";
import { createEmptyTask } from "src/database/factories";

export function Styleguide() {
  const form = createTaskFormContext();
  React.useEffect(() => {
    form.create(createEmptyTask({ order: "" }));
  }, []);
  return (
    <div>
      <h1>Styleguide</h1>
      <p>This is the styleguide page.</p>
      <TaskForm form={form} />
    </div>
  );
}
